import { Heading } from '@lmc/ui-kit'
import React, { type ReactElement } from 'react'
import styled from 'styled-components'

interface PercentageTextProps {
  percentage: string
  label: string
}
export const PercentageText = ({
  percentage,
  label
}: PercentageTextProps): ReactElement => (
  <CentaredWrapper>
    <CustomHeadingsContainer>
      <Colored3Heading level={1}>{percentage}</Colored3Heading>
      <PercentageHeading level={1}>%</PercentageHeading>
    </CustomHeadingsContainer>
    <Colored5Heading level={3}>{label}</Colored5Heading>
  </CentaredWrapper>
)

const CustomHeadingsContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
`

const CentaredWrapper = styled.div`
  display: flex;
  height: 100%;
  gap: 16px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const Colored3Heading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
  font-size: 96px;
  font-weight: 500;
  line-height: 96px;
`

const PercentageHeading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color3};
  font-size: 46px;
  font-weight: 800;
  line-height: 70px;
`

const Colored5Heading = styled(Heading)`
  color: ${(props) => props.theme.color.neutral.color5};
  font-weight: 400;
`

export default PercentageText
